module.exports = __webpack_public_path__ + "img/info-photo.aa5eb284.svg";